import { Icon } from '@sunwebgroup/uds-ui/icon'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { TopNavigationBarItem } from '@/scopes/common/components/Header'
import { usePaymentActions, usePaymentStep } from '@/scopes/payment/domain/PaymentContext'
import { isFullOnlyPayment } from '@/scopes/payment/domain/policies/fullOnlyPayment'
import { usePaymentStore } from '@/scopes/payment/infrastructure/usePaymentStore'

interface PaymentBackButtonProps {
  /** Rendered when there is no amount-choice step to return to. */
  children: React.ReactNode
  /** Applied to the wizard "go to amounts" button, to match the styling of `children`. */
  className?: string
}

export function PaymentBackButton({ children, className }: PaymentBackButtonProps) {
  const intl = useIntl()
  const { isWizard, step } = usePaymentStep()
  const actions = usePaymentActions()
  const paymentOptions = usePaymentStore(state => state.paymentOptions)
  const isFullOnly = paymentOptions && isFullOnlyPayment(paymentOptions.paymentAmounts)

  if (isWizard && step === 'methods' && !isFullOnly) {
    return (
      <TopNavigationBarItem className={className} as="button" onClick={() => actions.amountsStepRequested()} type="button">
        <Icon glyph="ChevronLeft" />
        {intl.formatMessage({ id: 'payment_scope_go_to_payment_options' })}
      </TopNavigationBarItem>
    )
  }

  return <>{children}</>
}
